<style lang="sass" scoped>
@import "../../../../../css/core";

.-row {
  position: relative;
}

.-bar {
  position: absolute;
  box-shadow: 2px 2px 2px -1px #aaa;
  background-color: $color-blue;
}
</style>


<template>
<div class="reservations-table-staffs-shift-body">
  <div class="-row" v-bind:style="rowStyle">
    <div
        v-for="t in ticks"
        class="-cell"
        v-bind:style="cellStyleByTick(t)"
        @mouseover="$dispatch('tick-over', t)"
        @mouseout="$dispatch('tick-out', t)"
    ></div>
    <div v-for="shift in shiftsWithRow" class="-bar" v-bind:style="barStyle(shift)"></div>
    <time-pointer
        :business-hour="businessHour"
        :px-per-minute="pxPerMinute"
        :height="height"
    ></time-pointer>
  </div>
</div>
</template>


<script>
import moment from 'moment'

export default {
  name: 'reservations-table-staffs-shift-body',
  mixins: [require('../body.vue')],
  props: {
    staffs: {
      type: Array,
      required: true,
    },
    shifts: {
      type: Array,
      required: true,
    },
  },
  computed: {
    shiftsWithRow() {
      var staffPks = this.staffs.map(staff => staff.pk)
      return this.shifts.map(shift => {
        return Object.assign({}, shift, {
          row: staffPks.indexOf(shift.staff)
        })
      })
    },
    rowHeight() {
      return this.height / this.staffs.length
    },
  },
  methods: {
    barStyle(shift) {
      let openToStart = moment.range(`${this.businessHour.openAt}/${shift.startAt}`)
      let startToEnd = moment.range(`${shift.startAt}/${shift.endAt}`)
      return {
        top: this.rowHeight * shift.row + this.rowHeight / 4 + 'px',
        left: openToStart.diff('minutes') * this.pxPerMinute + 'px',
        width: startToEnd.diff('minutes') * this.pxPerMinute + 'px',
        height: this.rowHeight / 2 + 'px',
      }
    },
  },
  components: {
    timePointer: require('../time-pointer.vue')
  },
}
</script>



// WEBPACK FOOTER //
// body.vue?131e8a21